// type styleConfig = {
//   message: Record<string, TextStyleValue>;
// };
export const getStyleConfig = (isMobile: boolean) => {
  return {
    message: {
      small: {
        fontStyle: 'normal',
        fontWeight: 'normal',
        fontSize: isMobile ? 11 : 12
      },
      medium: {
        fontStyle: 'normal',
        fontWeight: 'normal',
        fontSize: isMobile ? 12 : 14
      },
      large: {
        fontStyle: 'normal',
        fontWeight: 'normal',
        fontSize: isMobile ? 14 : 16
      }
    },
    button: {
      small: {
        font: {
          fontStyle: 'normal',
          fontWeight: 'bold',
          fontSize: isMobile ? 11 : 12
        },
        verticalPadding: isMobile ? 5 : 6,
        horizontalPadding: isMobile ? 6 : 12
      },
      medium: {
        font: {
          fontStyle: 'normal',
          fontWeight: 'bold',
          fontSize: isMobile ? 12 : 14
        },
        verticalPadding: isMobile ? 6 : 7,
        horizontalPadding: isMobile ? 7 : 14
      },
      large: {
        font: {
          fontStyle: 'normal',
          fontWeight: 'bold',
          fontSize: isMobile ? 14 : 16
        },
        verticalPadding: isMobile ? 6 : 8,
        horizontalPadding: isMobile ? 8 : 16
      }
    },
    link: {
      small: {
        fontStyle: 'normal',
        fontWeight: 'bold',
        fontSize: isMobile ? 11 : 12
      },
      medium: {
        fontStyle: 'normal',
        fontWeight: 'bold',
        fontSize: isMobile ? 12 : 14
      },
      large: {
        fontStyle: 'normal',
        fontWeight: 'bold',
        fontSize: isMobile ? 14 : 16
      }
    },
    icon: {
      small: isMobile ? 16 : 20,
      medium: isMobile ? 20 : 24,
      large: isMobile ? 24 : 28
    }
  };
};
